module.exports = __webpack_public_path__ + "img/full.bab2b876.png";